import formModel from './permissionsFormModel';

const {
    formField: {
        name,
        icon,
        slug,
        description,
        application_id,
        childrens
    }
} = formModel;

export default {
    [name.name]: '',
    [icon.name]: '',    
    [slug.name]: '',
    [description.name]: '',
    [application_id.name]: '',
    [childrens.name]: '[]'
};
